import { ReactNode } from "react";

import { FormattedMessage } from "react-intl";

import { Link } from "@/libraries/design/components";
import { useLocalizedHref } from "@/libraries/web-framework";

export interface EulaTextProps {
    readonly customLinkColor?: string;
}

export const EulaText = () => {
    const signupBundle = new URLSearchParams(window.location.search).get(
        "bundle"
    );
    const isCompass = signupBundle === "compass";

    const termsOfServiceLinkHref = useLocalizedHref(
        "/legal/cloud-terms-of-service"
    );
    const aiTermsLinkHref = useLocalizedHref(
        "/legal/product-specific-terms#atlassian-intelligence-specific-terms"
    );
    const privacyPolicyLinkHref = useLocalizedHref(
        "/legal/privacy-policy#what-this-policy-covers"
    );

    const messageId = isCompass
        ? "BxpUiSignup.SignupForm.compass.termsAndConditions"
        : "BxpUiSignup.SignupForm.termsAndConditions";

    const defaultMessage = isCompass
        ? "I agree to the <termsOfServiceLink> Atlassian Customer Agreement</termsOfServiceLink>, and <privacyPolicyLink>Privacy Policy</privacyPolicyLink>. Atlassian will collect, use, and process data from across your Atlassian products, which may include data originating from connected third party apps, in accordance with the <termsOfServiceLink> Atlassian Customer Agreement</termsOfServiceLink> and <privacyPolicyLink>Privacy Policy</privacyPolicyLink>."
        : "I agree to the <termsOfServiceLink>Atlassian Customer Agreement</termsOfServiceLink>, which incorporates by reference the <aiTermsLink>AI Product-Specific Terms</aiTermsLink>, and acknowledge the <privacyPolicyLink>Privacy Policy</privacyPolicyLink>.";

    return (
        <FormattedMessage
            id={messageId}
            defaultMessage={defaultMessage}
            values={{
                termsOfServiceLink: (text: ReactNode) => (
                    <Link
                        text={text as unknown as string}
                        aria-label={text as unknown as string}
                        type="inline"
                        href={termsOfServiceLinkHref}
                        className="linkText"
                    />
                ),
                aiTermsLink: (text: ReactNode) => (
                    <Link
                        text={text as unknown as string}
                        aria-label={text as unknown as string}
                        type="inline"
                        href={aiTermsLinkHref}
                        className="linkText"
                    />
                ),
                privacyPolicyLink: (text: ReactNode) => (
                    <Link
                        text={text as unknown as string}
                        aria-label={text as unknown as string}
                        type="inline"
                        href={privacyPolicyLinkHref}
                        className="linkText"
                    />
                )
            }}
        />
    );
};
